// module
import React from 'react';
import ReactDom from 'react-dom';
import PropTypes from 'prop-types';

class ShowImg extends React.Component {
    constructor(props){
        super(props);

        this.state={
            isOpen:false
        };

        this.myRef = React.createRef();
        this.popUpImg = this.popUpImg.bind(this);
    };

    popUpImg(){
        this.setState({ isOpen: !this.state.isOpen });
    };

    componentDidMount(){
        let imgTag = ReactDom.findDOMNode(this.myRef.current);
        imgTag.addEventListener("click", this.popUpImg);
    };

    render(){
        const {name, src} = this.props;
        return(
            <label className="popUpLink" ref={this.myRef}>
                {name}
                {this.state.isOpen && (
                <dialog
                    className="popUpDialog"
                    open
                    onClick={this.popUpImg}
                >
                    <img
                    className="image"
                    src={src}
                    onClick={this.popUpImg}
                    alt="not Found"
                    />
                </dialog>
                )}
            </label>
        );
    }
}

ShowImg.propTypes={
    src: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
}

export default ShowImg;